import { useMutation } from '@tanstack/react-query';

import { MutationConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

type UploadImageOptions = {
  mutationConfig?: MutationConfig<typeof uploadImage>;
};

type UploadDocumentType = {
  image: File;
  estateId: string;
};

type UploadDocumentsType = {
  images: FileList;
  estateId: string;
};

export const uploadImage = ({ image, estateId }: UploadDocumentType) => {
  return extractData(api.estates({ id: estateId }).images.post({ image }));
};

const uploadImages = ({ images, estateId }: UploadDocumentsType) => {
  return extractData(api.estates({ id: estateId }).images.batch.post({ images }));
};

export const useUploadImage = ({ mutationConfig }: UploadImageOptions = {}) => {
  return useMutation({
    ...mutationConfig,
    mutationFn: uploadImages,
  });
};
